export class ElementRender {
    private _container: d3.Selection<any>;
    private _visible: boolean;
    private _height: number;
    private _width: number;
    constructor(selection: d3.Selection<any>,
        classed: string) {
        this._container = selection.append('g')
            .classed(classed, true);
    }

    container(): d3.Selection<any> {
        return this._container;
    }

    height(): number;
    height(value: number): this;
    height(value?: number): this | number {
        if (!arguments.length) {
            return this._height;
        }
        this._height = value;
        return this;
    }

    width(): number;
    width(value: number): this;
    width(value?: number): this | number {
        if (!arguments.length) {
            return this._width;
        }
        this._width = value;
        return this;
    }

    private _ratio: number = 1;
    ratio(): number;
    ratio(value: number): this;
    ratio(value?: number) {
        if (arguments.length) {
            this._ratio = value;
            return this;
        }
        return this._ratio;
    }

    visible(): boolean;
    visible(value: boolean): this;
    visible(value?: boolean): this | boolean {
        if (!arguments.length) {
            return this._visible;
        }
        this._visible = value;
        return this;
    }
}